import styled from "styled-components";

export default styled.div`
    justify-content: flex-end;
    align-items: center;
    display: flex;
    z-index: 10;
`;
